var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGenesysLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 25 40",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Untitled"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3509 2.30576C21.3534 2.30576 22.1554 3.10777 22.1554 4.11028C22.1554 5.11278 21.3534 5.91479 20.3509 5.91479L20.2506 5.91479C19.3484 5.91479 18.5464 5.11278 18.5464 4.21053C18.5464 3.70927 18.7469 3.20802 19.0476 2.90727C19.3484 2.50627 19.8496 2.30576 20.3509 2.30576M20.3509 0C18.0451 0 16.1404 2.00501 16.2406 4.31078C16.3409 6.41604 18.0451 8.1203 20.1504 8.22055C20.2506 8.22055 20.2506 8.22055 20.3509 8.22055C22.6566 8.22055 24.4612 6.31579 24.4612 4.11028C24.4612 1.90476 22.5564 0 20.3509 0L20.3509 0Z",
    fill: "currentColor",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5439 28.9724C19.8496 28.9724 21.7544 30.8772 21.7544 33.183C21.7544 35.4887 19.8496 37.3935 17.5439 37.3935L13.0326 37.3935C10.7268 37.3935 8.82206 35.4887 8.82206 33.183C8.82206 30.8772 10.7268 28.9724 13.0326 28.9724L17.5439 28.9724M17.5439 26.1654L13.0326 26.1654C9.22306 26.1654 6.11529 29.2732 6.11529 33.0827C6.11529 36.8922 9.22306 40 13.0326 40L17.5439 40C21.3534 40 24.4612 36.8922 24.4612 33.0827C24.4612 29.2732 21.3534 26.1654 17.5439 26.1654L17.5439 26.1654Z",
    fill: "currentColor",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5439 12.7318C19.8496 12.7318 21.7544 14.6366 21.7544 16.9424C21.7544 19.2481 19.8496 21.1529 17.5439 21.1529L6.91729 21.1529C4.61153 21.1529 2.70677 19.2481 2.70677 16.9424C2.70677 14.6366 4.61153 12.7318 6.91729 12.7318L17.5439 12.7318M17.5439 10.0251L6.91729 10.0251C3.10777 10.0251 0 13.1328 0 16.9424C0 20.7519 3.10777 23.8596 6.91729 23.8596L17.5439 23.8596C21.3534 23.8596 24.4612 20.7519 24.4612 16.9424C24.4612 13.1328 21.3534 10.0251 17.5439 10.0251L17.5439 10.0251Z",
    fill: "currentColor",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenesysLogo);
export default __webpack_public_path__ + "static/media/genesys-logo.6e607752582fc4685d0abf0d69355e5f.svg";
export { ForwardRef as ReactComponent };